import { Component, Input, IterableDiffers, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DataBindingDirective } from '@progress/kendo-angular-grid';
import { isNullOrEmptyString, is } from '../../../../../shared/utils.js';
import { isNullOrUndefined } from 'util';
import { CLPUser } from '../../../../models/clpuser.model';
import { ContactList } from '../../../../models/contact-modal/contact.model';
import { ContactService } from '../../../../services/contact.service';
import { NotificationService } from '../../../../services/notification.service';
import { GridConfigurationService } from '../../../../services/contact-services/shared/gridConfiguration.service';
import { LocalService } from '../../../../services/contact-services/shared/local.service';
import { process } from '@progress/kendo-data-query';
import { ContactSearchService } from '../../../../services/contact-services/shared/contact-search.service';
import { RoleFeaturePermissions } from '../../../../models/roleContainer.model';
import { GlobalService } from '../../../../services/contact-services/global.service';
import { ReportService } from '../../../../services/contact-services/report.service';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { PDFExportComponent } from '@progress/kendo-angular-pdf-export';
import { MatTableDataSource } from '@angular/material/table';
import { Subject, takeUntil } from 'rxjs';
declare var $: any;

@Component({
    selector: 'app-contact-map-common',
    templateUrl: './contact-map-common.component.html',
    styleUrls: ['./contact-map-common.component.css'],
    providers: [GridConfigurationService]
})
export class ContactMapCommonComponent implements OnInit {
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild('pdfExport') pdfExport!: PDFExportComponent;
    contactsMapDataSource: MatTableDataSource<any>;
    showSpinner: boolean = false;
    initContactsMapData: ContactList[] = [];
    @Input() contactsMapData: ContactList[] = [];
    @Input() user: CLPUser;
    @Input() roleFeaturePermissions: RoleFeaturePermissions;
    @Input() isDownload: boolean = false;
    @Input() isSearch: boolean = false;
    @Input() isFromContactMap: boolean = false
    private encryptedUser: string = '';
    @Input() isContactReport: boolean = false;
    sendMailInfo: any = { isShow: false, contactId: 0 };
    selectedId: number = 0;
    dateFormat: string = "MM/dd/yyyy";
    @ViewChild(DataBindingDirective) dataBinding: DataBindingDirective;
    gridHeight;
    engageUrl: any;
    mobileColumnNames: string[];
    columns: { field: string; title: string; width: string; }[];
    reorderColumnName: string;
    columnWidth: string;
    arrColumnWidth: string[];
    selectedContactData: any;
    selectedCallType: string;
    isShowNewCallModal: boolean;
    skip: number = 0;
    totalContactCount: number = 0;
    exporting: boolean = false;
    contactListDisplayColumns: any[] = [];
    private destroy$ = new Subject<void>();

    constructor(public _localService: LocalService,
        private _notifyService: NotificationService,
        private _router: Router,
        public _contactService: ContactService,
        differs: IterableDiffers,
        public _contactSearchService: ContactSearchService,
        private _reportService: ReportService,
        private _globalService: GlobalService,
        public _gridCnfgService: GridConfigurationService) {
        //this.gridHeight = this._localService.getGridHeight('499px');
    }

    ngOnInit() {
        this._globalService.getToken((token) => {
            if (token) {
                this.encryptedUser = token;
                if (this.user) {
                    this.dateFormat = this.user.dateFormat;
                    if (!isNullOrUndefined(this.contactsMapData))
                        this.initContactsMapData = this.contactsMapData;
                    this.getGridConfiguration();
                    this.setContactCount();
                }
                else
                    this._router.navigate(['/login']);
            }
            else
                this._router.navigate(['/login']);
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        this.timeouts.forEach(id => clearTimeout(id));
        this.timeouts.clear();
    }

    setContactCount() {
        this._reportService.curTotalContactCount.pipe(takeUntil(this.destroy$)).subscribe(data => {
            this.totalContactCount = data;
        });
    }

    getGridConfiguration() {
        if (this.isFromContactMap) {
            this.columns = [
                { field: '$', title: ' ', width: '40' },
                { field: '$$', title: '  ', width: '40' },
                { field: 'name', title: 'Name', width: '250' },
                { field: 'address', title: 'Address', width: '120' },
                { field: 'dtModifiedDisplay', title: 'Modified', width: '100' },
                { field: 'dtCreatedDisplay', title: 'Created', width: '90' },
            ];
            //this.reorderColumnName = 'name,address,dtModifiedDisplay,dtCreatedDisplay';
            //this.columnWidth = 'name:250,address:120,dtModifiedDisplay:100,dtCreatedDisplay:90';
            //this.arrColumnWidth = ['name:250,address:120,dtModifiedDisplay:100,dtCreatedDisplay:90'];
        }
        else {
            //this.columns = [
            //    { field: '$', title: ' ', width: '40' },
            //    { field: '$$', title: '  ', width: '40' },
            //    { field: 'name', title: 'Name', width: '184' },
            //    { field: 'email', title: 'Email', width: '89' },
            //    { field: 'text', title: 'Text', width: '89' },
            //    { field: 'coCompanyName', title: 'Company', width: '159' },
            //    { field: 'title', title: 'Title', width: '100' },
            //    { field: 'address', title: 'Address', width: '142' },
            //    { field: 'city', title: 'City', width: '102' },
            //    { field: 'state', title: 'State', width: '102' },
            //    { field: 'country', title: 'Country', width: '102' },
            //    { field: 'zip', title: 'Zip', width: '82' },
            //    { field: 'emailAddress', title: 'Email Address', width: '162' },
            //    { field: 'mobile', title: 'Phone', width: '142' },
            //    { field: 'userName', title: 'User', width: '142' },
            //    { field: 'dtModifiedDisplay', title: 'Modified', width: '104' },
            //    { field: 'dtCreatedDisplay', title: 'Created', width: '112' },
            //];

            this.columns = [
                { field: '$', title: ' ', width: '40' },
                { field: '$$', title: '  ', width: '40' },
                { field: 'name', title: 'Name', width: '184' },
                { field: 'email', title: 'Email', width: '89' },
                { field: 'text', title: 'Text', width: '89' },
                { field: 'coCompanyName', title: 'Company', width: '159' },
                { field: 'mobile', title: 'Phone', width: '142' },
                { field: 'userName', title: 'User', width: '142' },
                { field: 'dtModifiedDisplay', title: 'Modified', width: '104' },
                { field: 'dtCreatedDisplay', title: 'Created', width: '112' },
            ];

            //this.reorderColumnName = 'name,email,text,coCompanyName,title:h,address,city:h,state:h,country:h,zip:h,emailAddress:h,mobile,userName,dtModifiedDisplay,dtCreatedDisplay';
            //this.columnWidth = 'name:184,email:89,text:89,coCompanyName:159,title:100,address:142,city:102,state:102,country:102,zip:82,emailAddress:162,mobile:142,userName:142,dtModifiedDisplay:104,dtCreatedDisplay:112';
            //this.arrColumnWidth = ['name:184,email:89text:89,coCompanyName:159,title:100,address:142,city:102,state:102,country:102,zip:82,emailAddress:162,mobile:142,userName:142,dtModifiedDisplay:104,dtCreatedDisplay:112'];

        }

        this.contactListDisplayColumns = this.columns.map(c => c.field);
        //this._gridCnfgService.columns = this.columns;
        //this._gridCnfgService.reorderColumnName = this.reorderColumnName;
        //this._gridCnfgService.columnWidth = this.columnWidth;
        //this._gridCnfgService.arrColumnWidth = this.arrColumnWidth;
        //this._gridCnfgService.user = this.user;
        //this._gridCnfgService.getGridColumnsConfiguration(this.user.cLPUserID, 'contact_map_grid').subscribe((value) => this._gridCnfgService.createGetGridColumnsConfiguration('contact_map_grid').subscribe((value) => this.getMapContacts()));
        this.setContactListGrid(this.contactsMapData);
    }


    resetGridSetting() {
        this._gridCnfgService.deleteColumnsConfiguration(this.user.cLPUserID, 'contact_map_grid').pipe(takeUntil(this.destroy$)).subscribe((value) => this.getGridConfiguration());
    }

    getMapContacts() {
        if (!isNullOrUndefined(this._gridCnfgService)) {
            this._gridCnfgService.iterateConfigGrid(true, "contact_map_grid");
            this.mobileColumnNames = this._gridCnfgService.getResponsiveGridColums('contact_map_grid');
        }
    }

    gotoLink(columnName, dataItem) {
        var url = this.engageUrl;
        if (columnName) {
            switch (columnName) {
                case "address-card":
                case "name": {
                    if (this.user.timeZoneWinId != 0) {
                        let url = '/contact/' + dataItem.contactID;
                        return url;
                    }
                    else {
                        if (confirm("First , Please select your timezone!!!"))
                            this._router.navigate(['/edit-profile', dataItem.cLPUserID]);
                        else
                            return;
                    }
                    break;
                }
                case "userName": {
                    return `/edit-profile/${dataItem.cLPUserID}`;
                }
                case "lead":
                    return `/lead-detail/${dataItem?.LeadID}`;
                case "coCompanyName": {
                    return `company-create?cid=${dataItem?.companyID}`;
                }
                case "email": {
                    $('#sendEmailModal').modal('show');
                    this.sendMailInfo.isShow = true;
                    this.sendMailInfo.contactId = dataItem?.contactID;
                    break;
                }
                default: {
                    break;
                }
            }
        }
    }

    public saveExcel(component): void {
        let indexs: number[] = [];
        const options = component.workbookOptions();
        options.sheets[0].name = `Contact List`;
        let rows = options.sheets[0].rows;
        this._gridCnfgService.hiddenColumns.forEach(item => { indexs.push(rows[0].cells.findIndex(i => i.value == item)) });
        rows.forEach((row) => {
            if (row) {
                row.cells.forEach((cell, index) => {
                    indexs.forEach(i => {
                        if (i == index)
                            row.cells.splice(index, 1);
                    })
                    if (cell && cell.value && cell.value.includes("<br>")) {
                        cell.value = cell.value.replace(/<br\s*\/?>/gi, ' ');
                    }
                });
            }
        });
        Array.prototype.unshift.apply(rows);
        component.save(options);
    }

    showColumn(columnDef): boolean {
        var value = true;
        if (columnDef) {
            (columnDef == 'email') || (columnDef == 'phone') ? value = false : value = true;
        }
        return value;
    }

    onContactMapListFilter(inputValue: string): void {
        this.contactsMapData = process(this.initContactsMapData, {
            filter: {
                logic: "or",
                filters: [
                    { field: 'name', operator: 'contains', value: inputValue },
                    { field: 'email', operator: 'contains', value: inputValue }

                ],
            }
        }).data;
        this.dataBinding.skip = 0;
    }

    hideSendMail() {
        $('#sendEmailModal').modal('hide');
        this.sendMailInfo.isShow = false;
        this.sendMailInfo.contactId = 0;
    }

    openModalNewCall(contactData, callType: string) {
        this.selectedContactData = contactData;
        this.selectedCallType = callType;
        this.isShowNewCallModal = true;
    }


    showTextMail(contactId) {
        this.selectedId = contactId;
        $('#sendTextModal').modal('show');

    }

    hideTextMsgModal(sms?: boolean) {
        this.selectedId = 0;
        $('#sendTextModal').modal('hide');
    }

    ngOnChanges() {
        this.skip = 0;
        this.getGridConfiguration();
        //this.setContactListGrid(this.contactsMapData)
    }

    //onPageChange(event: any) {
    //    this.skip = event.skip;
    //}

    onPageChange(event: any) {
        localStorage.setItem('pageSize', event.pageSize);
    }

    setContactListGrid(contactList) {
        this.contactListDisplayColumns = this.columns.map(c => c.field);
        this.contactsMapDataSource = new MatTableDataSource(contactList);
        this.addTimeout(() => {
            this.contactsMapDataSource.paginator = this.paginator;
            if (this.paginator) {
                this.paginator.pageSize = this._localService.getPageSize('contact_map_grid') ? this._localService.getPageSize('contact_map_grid') : 50;
            }
            if (this.sort) {
                this.contactsMapDataSource.sort = this.sort;
                const sortState: Sort = this._localService.getSortState('contact_map_grid');
                this.sort.active = sortState?.active;
                this.sort.direction = sortState?.direction;
                this.sort.sortChange.emit(sortState);
                this.contactsMapDataSource.sortingDataAccessor = (item, property) => {
                    switch (property) {
                        case 'userName':
                            return (item.uLastName + ', ' + item.uFirstName).toLowerCase();
                        case 'dtModifiedDisplay':
                            return item.dtModified;
                        case 'dtCreatedDisplay':
                            return item.dtCreated;
                        default:
                            return item[property];
                    }
                };
            }
        }, 500)
    }

    getSerialNumber(index: number): number {
        return index + 1 + (this.paginator?.pageIndex || 0) * (this.paginator?.pageSize || 5);
    }

    applyFilter(filterValue: string) {
        filterValue = filterValue.trim().toLowerCase();

        if (this.contactsMapDataSource) {
            this.contactsMapDataSource.filterPredicate = (data: any, filter: string) => {
                return Object.keys(data).some((key) => {
                    return data[key]?.toString().toLowerCase().includes(filter);
                });
            };

            this.contactsMapDataSource.filter = filterValue;
        }
    }

    exportPDF() {

        this.exporting = true;
        this.addTimeout(() => {
            this.pdfExport.saveAs('ContactsList.pdf')
        }, 100);
        this.addTimeout(() => { this.exporting = false }, 500);
    }

    private timeouts = new Set<ReturnType<typeof setTimeout>>();
    addTimeout(callback, timeout) {
        const id = setTimeout(() => {
            if (callback) {
                callback();
            }
            this.timeouts.delete(id);
        }, timeout);
        this.timeouts.add(id);
    }

}
